import React, { useState, useEffect } from "react";
import ExpandableWithToggle from "../../../../components/BasicComponents/ExpandableWithToggle";

export default function MultiValueDropDown({
  selectedFilterValues,
  allOptions,
  setSelectedFilters,
  dispatchUpdateItem,
  showApplyBtn,
  data,
  filterItem,
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedOptions, setSelectedOptions] = useState(
    Array.isArray(selectedFilterValues) ? selectedFilterValues : []
  );
  // console.log(filterItem.columnName);
  // // console.log(selectedFilterValues);
  // // console.log(selectedOptions);
  // // console.log(showApplyBtn);
  const [selectAll, setSelectAll] = useState(
    filterItem?.isAll ? filterItem.isAll : false
  );
  const [tempSelectedOptions, setTempSelectedOptions] = useState(
    Array.isArray(selectedFilterValues) ? selectedFilterValues : []
  );
  const [expantion, setExpantion] = useState(false);
  // // console.log(expantion);

  const handleTextInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    const validFilterValues = Array.isArray(selectedFilterValues)
      ? selectedFilterValues
      : [];
    setSelectedOptions(validFilterValues);
    setTempSelectedOptions(validFilterValues);
    setSelectAll(
      allOptions.length && validFilterValues.length === allOptions.length
    );
  }, [selectedFilterValues, allOptions]);

  const filteredOptions = allOptions.filter((option) => {
    if (typeof option === "string") {
      return option.toLowerCase().includes(searchTerm.toLowerCase());
    } else if (typeof option === "number") {
      return option.toString().toLowerCase().includes(searchTerm.toLowerCase());
    }
    return false;
  });
  useEffect(() => {
    setSelectAll(
      allOptions.length && tempSelectedOptions.length === allOptions.length
    );
  }, [allOptions, tempSelectedOptions]);

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    if (newSelectAll) {
      // Selecting all options
      setTempSelectedOptions(allOptions);
      setSelectedOptions(allOptions);
      setSelectedFilters(allOptions);
      if (!showApplyBtn) {
        dispatchUpdateItem(allOptions, newSelectAll); // Pass the updated selectAll state
      }
    } else {
      // deSelecting all options
      setTempSelectedOptions([]);
      setSelectedOptions([]);
      setSelectedFilters([]);
      if (!showApplyBtn) {
        dispatchUpdateItem([], newSelectAll); // Pass the updated selectAll state
      }
    }
    setSelectAll(newSelectAll);
  };

  const handleCheckboxChange = (value, allOptions) => {
    const newTempSelectedOptions = tempSelectedOptions.includes(value)
      ? tempSelectedOptions.filter((item) => item !== value)
      : [...tempSelectedOptions, value];
    const isAll = newTempSelectedOptions.length === allOptions.length;
    // console.log(newTempSelectedOptions);
    // console.log(isAll);
    if (showApplyBtn) {
      setTempSelectedOptions(newTempSelectedOptions);
    } else {
      setSelectedOptions(newTempSelectedOptions);
      setSelectedFilters(newTempSelectedOptions);
      dispatchUpdateItem(newTempSelectedOptions, isAll);
    }
  };

  const handleApply = (options, allOptions) => {
    const isAll = options.length === allOptions.length;
    // console.log(isAll);
    setSelectedOptions(tempSelectedOptions);
    setSelectedFilters(tempSelectedOptions);
    dispatchUpdateItem(tempSelectedOptions, isAll);
    setExpantion(false);
  };

  const handleCancel = () => {
    setTempSelectedOptions(selectedOptions);
    setSelectAll(
      allOptions.length && selectedOptions.length === allOptions.length
    );
  };

  const formatSelectedOptions = (selectedOptions) => {
    if (!Array.isArray(selectedOptions)) return "";
    return selectedOptions.join(",");
  };
  // console.log(filteredOptions.length);

  return (
    <main className="px-1 py-1 flex flex-col overflow-y-auto w-full">
      <ExpandableWithToggle
        componentType={"ASIDE3FILTERS"}
        aside3Title={`(${
          selectAll ? "All" : formatSelectedOptions(selectedOptions)
        })`}
        showApplyBtn={showApplyBtn}
        expantion={expantion}
        setExpantion={setExpantion}
      >
        <section className="w-full flex flex-col gap-1 shadow items-center justify-start rounded p-2 border-[1px]">
          <div className="flex items-center justify-center w-full">
            {/* <FaSearch className="text-gray-300" /> */}
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleTextInputChange}
              className="px-2 border rounded text-base h-7 w-full focus:outline-none font-light"
            />
          </div>
          <button
            className="flex items-center justify-left font-light w-full"
            onChange={handleSelectAll}
          >
            <input
              type="checkbox"
              id="checkbox-all"
              checked={selectAll}
              className="mr-[6px] checkbox-input"
            />
            <label
              htmlFor="checkbox-all"
              className="truncate cursor-pointer text-sm font-light"
            >
              All
            </label>
          </button>
          <div
            className={`w-full ${
              filteredOptions.length <= 4 ? "h-auto" : "h-[7rem]"
            } overflow-y-auto`}
          >
            {filteredOptions.map((option, index) => (
              <button
                key={index}
                className="cursor-pointer flex items-center mb-1 w-full truncate font-light"
              >
                <input
                  type="checkbox"
                  id={`checkbox-${index}`}
                  value={option}
                  checked={tempSelectedOptions.includes(option)}
                  onChange={() => handleCheckboxChange(option, allOptions)}
                  className="mr-[6px] checkbox-input cursor-pointer"
                />
                <label
                  htmlFor={`checkbox-${index}`}
                  className="truncate w-full text-left cursor-pointer text-sm font-light"
                >
                  {option}
                </label>
              </button>
            ))}
          </div>

          {showApplyBtn && (
            <div className="flex justify-between items-center w-full gap-2">
              <button
                className="bg-gray-200 text-black py-[2px] px-1 text-sm"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                className="bg-blue-950 text-white py-[2px] px-1 text-sm"
                onClick={() => handleApply(tempSelectedOptions, allOptions)}
              >
                Apply
              </button>
            </div>
          )}
        </section>
      </ExpandableWithToggle>
    </main>
  );
}
